import { TASK_STATUS_LABELS, type TaskStatus } from "@quovy/types";

/**
 * @deprecated Prefer `TaskStatus` from `@quovy/types`. Kept as an alias for
 * call sites that still import from this file.
 */
export type TaskUiStatus = TaskStatus;

export const STATUS_LABELS: Record<TaskStatus, string> = TASK_STATUS_LABELS;

export const STATUS_CLASSES: Record<TaskStatus, string> = {
  triage: "border-amber-300 bg-amber-50 text-amber-700",
  backlog: "border-zinc-300 bg-zinc-100 text-zinc-700",
  todo: "border-sky-300 bg-sky-50 text-sky-700",
  in_progress: "border-blue-300 bg-blue-50 text-blue-700",
  in_review: "border-violet-300 bg-violet-50 text-violet-700",
  blocked: "border-rose-300 bg-rose-50 text-rose-700",
  done: "border-emerald-300 bg-emerald-50 text-emerald-700",
  canceled: "border-zinc-300 bg-zinc-100 text-zinc-500",
};

export function formatTaskStatusLabel(status: TaskStatus) {
  return STATUS_LABELS[status];
}
